export function calculateLifeExpectancy(
  product,
  startingMilesDrivenPerYear,
  updatedMilesDrivenPerYear
) {
  if (
    !product ||
    !product.recommendationData ||
    !startingMilesDrivenPerYear ||
    !updatedMilesDrivenPerYear
  ) {
    return { tireLifeMonths: 0, tireLifeYears: 0 };
  }
  const expectedMonths =
    product.recommendationData.tireLifeYears * 12 +
    product.recommendationData.tireLifeMonths;
  const totalMonths =
    (startingMilesDrivenPerYear / updatedMilesDrivenPerYear) * expectedMonths >
    120
      ? 120
      : (startingMilesDrivenPerYear / updatedMilesDrivenPerYear) *
        expectedMonths;

  const result = {
    tireLifeMonths: Math.floor(totalMonths % 12),
    tireLifeYears: Math.floor(totalMonths / 12)
  };

  return result;
}
